// Helpers for restaurant packages (see migration 023 + components/PackageManager.jsx)

/** Find the package record for a booking's packageName (case-insensitive). */
export function findPackage(packages, name) {
  if (!name) return null;
  const key = String(name).trim().toLowerCase();
  return (packages || []).find((p) => (p.name || '').trim().toLowerCase() === key) || null;
}

const AFTERNOON_TEA_RE = /afternoon\s*tea|high\s*tea/i;

/**
 * True when a table booking needs the kitchen to order the day before.
 * Uses the package flag first; falls back to spotting "afternoon tea" in the
 * notes so bookings taken before the Package field existed are still caught.
 */
export function needsDayBeforeOrder(booking, packages) {
  const pkg = findPackage(packages, booking?.packageName);
  if (pkg) return !!pkg.kitchenOrderDayBefore;
  const text = `${booking?.packageName || ''} ${booking?.specialRequirements || ''} ${booking?.notes || ''}`;
  return AFTERNOON_TEA_RE.test(text);
}

/** Short "name — inclusions · €x pp" line for a booking's package ('' if none). */
export function packageLabel(booking, packages) {
  if (!booking?.packageName) return { name: '', detail: '' };
  const pkg = findPackage(packages, booking.packageName);
  const parts = [];
  if (pkg?.inclusions) parts.push(pkg.inclusions);
  if (pkg?.pricePp) parts.push(`€${pkg.pricePp % 1 === 0 ? pkg.pricePp : pkg.pricePp.toFixed(2)} pp`);
  return { name: booking.packageName, detail: parts.join(' · ') };
}
